import { render } from "./ZonarIcon.vue?vue&type=template&id=ac42e150&ts=true"
import script from "./ZonarIcon.vue?vue&type=script&lang=ts"
export * from "./ZonarIcon.vue?vue&type=script&lang=ts"

import "./ZonarIcon.vue?vue&type=style&index=0&id=ac42e150&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__